exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1BFjVVwk3o8a9Y{margin:16px 40px 12px 56px;min-height:32px;position:relative;z-index:1}._33fqcaoh7LQ07u{left:-36px;position:absolute}._2AnV90mWRiGAIY{color:#172b4d;font-size:20px;font-weight:600;letter-spacing:-.008em;line-height:24px;margin-top:28px;margin:0;overflow-wrap:break-word}._1jOfioEpcUk4U7{color:#5e6c84;cursor:default;display:inline-block;margin:4px 12px 0 0}._3WdA2egBtGJFew{color:#5e6c84}._3bnPSnaIQ1mVE8{display:inline-block;vertical-align:middle}", ""]);

// exports
exports.locals = {
	"header": "_1BFjVVwk3o8a9Y",
	"cardIcon": "_33fqcaoh7LQ07u",
	"cardName": "_2AnV90mWRiGAIY",
	"cardLocation": "_1jOfioEpcUk4U7",
	"boardLink": "_3WdA2egBtGJFew",
	"subscribedIndicator": "_3bnPSnaIQ1mVE8"
};